import { render } from "./RxAdvice.vue?vue&type=template&id=6cd14a12&scoped=true"
import script from "./RxAdvice.vue?vue&type=script&lang=js"
export * from "./RxAdvice.vue?vue&type=script&lang=js"

import "./RxAdvice.vue?vue&type=style&index=0&id=6cd14a12&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd14a12"]])

export default __exports__